import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpClient = inject(HttpClient);

  private api: ApiService<any>;

  constructor() {
    this.api = new ApiService<any>(this.httpClient);
  }
  getUserRole(params?: any) {
    return this.api.getList('functions/getUserRole', params);
  }
}
